import { Add } from "@components/icons"
import MenuItem, { ButtonContainer, MenuItemProps } from "@components/MenuItem"
import animation, { cubicBezier } from "@constants/animation"
import colors from "@constants/colors"
import React from "react"
import styled from "styled-components"

const Container = styled.div``

const Label = styled(ButtonContainer)<{ expanded: boolean }>`
  color: ${colors.mediumGray};
  ${({ expanded }) =>
    expanded &&
    `
    height: 0;
    padding: 0;
    opacity: 0;
    transition: height ${animation.quick} ${cubicBezier} ${animation.quick},
      padding ${animation.quick} ${cubicBezier} ${animation.quick},
      opacity ${animation.quick} ${cubicBezier};
  `}
`

const IconWrapper = styled.div`
  width: 24px;
  height: 24px;
  margin-right: 5px;
  flex-shrink: 0;
  transition: transform ${animation.quick} ${cubicBezier};
`

const Content = styled.div<{
  expanded: boolean
  expandedHeight: number
}>`
  display: flex;
  height: ${({ expanded, expandedHeight }) =>
    expanded ? `${expandedHeight}px` : 0};
  flex-direction: column;
  transition: height ${animation.quick} ${cubicBezier};
  overflow: hidden;
`

export const anchorStylesMenu = `
  position: absolute;
  width: 100%;
  font-family: Avenir Roman;
  font-size: 16x;
  line-height: 20px;
  visibility: hidden;
`

export const anchorStylesMenuItem = `
  height: 53px;
  padding: 0 52px 0 20px;
`

export const anchorStylesSideNav = `
  position: absolute;
  width: calc(1.5 / 12 * 100vw);
  min-width: calc(300px - (0.5 / 12 * 100vw));
  font-family: Avenir Roman;
  font-size: 16x;
  line-height: 20px;
  visibility: hidden;
`

export const anchorStylesSideNavItem = `
  padding: 18px 10px 18px 20px;
`

interface MenuItemExpandableProps {
  anchorContainerStyles?: string
  anchorId?: string
  anchorItemStyles?: string
  items: Array<MenuItemProps>
  label: string
}

const MenuItemExpandable: React.FC<MenuItemExpandableProps> = ({
  anchorContainerStyles,
  anchorId,
  anchorItemStyles,
  items,
  label,
}) => {
  const [expanded, setExpanded] = React.useState<boolean>(false)

  const toggleExpanded = () => {
    setExpanded(!expanded)
  }

  const getExpandedHeight = () => {
    const anchor: HTMLElement | null = anchorId
      ? document.getElementById(anchorId)
      : document.getElementsByTagName("body")[0]

    if (!anchor) return 0

    const ruler: any = document.createElement("div")
    ruler.style = anchorContainerStyles
      ? anchorContainerStyles
      : anchorStylesMenu

    items.forEach(({ label }) => {
      const item: any = document.createElement("div")
      item.innerHTML = label
      item.style = anchorItemStyles ? anchorItemStyles : anchorStylesMenuItem
      ruler.appendChild(item)
    })

    anchor.appendChild(ruler)
    const rulerHeight = ruler.getBoundingClientRect().height
    anchor.removeChild(ruler)
    return rulerHeight
  }

  const [expandedHeight, setExpandedHeight] = React.useState<number>(0)

  React.useEffect(() => {
    setExpandedHeight(getExpandedHeight)
  }, [items])

  return (
    <Container>
      <Label expanded={expanded} onClick={toggleExpanded}>
        {label}
        <IconWrapper>
          <Add strokeColor={colors.mediumGray} />
        </IconWrapper>
      </Label>
      <Content expanded={expanded} expandedHeight={expandedHeight}>
        {items.map((props) => (
          <MenuItem key={`${label}-${props.label}`} {...props} />
        ))}
      </Content>
    </Container>
  )
}

export default MenuItemExpandable
